/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Data_Type_BooleanInputs */

const en_enum_setting_data_type_boolean = /** @type {(inputs: Enum_Setting_Data_Type_BooleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Type Boolean`)
};

const de_enum_setting_data_type_boolean = /** @type {(inputs: Enum_Setting_Data_Type_BooleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Typ Boolean`)
};

/**
* | output |
* | --- |
* | "Data Type Boolean" |
*
* @param {Enum_Setting_Data_Type_BooleanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_data_type_boolean = /** @type {((inputs?: Enum_Setting_Data_Type_BooleanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Data_Type_BooleanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_data_type_boolean(inputs)
	return de_enum_setting_data_type_boolean(inputs)
});